import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { formatToPercentage } from '@/shared/helpers/formatToPercentage';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const CommonPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  const isPartOnly = prize.partSize < 1;

  const percent = isPartOnly
    ? formatToPercentage((prize.collectedPartsCount ?? 0) / (prize.targetPartsCount ?? 0))
    : undefined;

  return (
    <>
      <div className={s.name}>{prize.name}</div>
      {isPartOnly && (
        <div className={clsx(s.description, s.fill)}>
          {t('Collected')}: <span className={s.value}>{percent}</span>
        </div>
      )}
    </>
  );
};
